import { GOOGLE_DRIVE_API, GOOGLE_DRIVE_CONFIG, SUPPORT_FILE_MIME_TYPES, GOOGLE_EXCLUSIVE_MIME_TYPE, setDriveTokenInfo, GOOGLE_DRIVE } from './drives.constants';
import axios from 'axios';
import { baseUrlApis } from 'Api/index';
import { store } from 'Store/index';
import {
  convertUTCToLocale,
  getFileSize, /* handlerFileNameWithoutExtension,  */
  getQueryVariable,
  windowActionFn,
  storageGetItem,
  storageRemoveItem,
  storageSetItem,
  getFileNameWithoutExtension,
  mimeMap,
  updateProp,
  saveDriveRefreshCode,
  getDriveRefreshCode, isCanvas, saveNeedReLoginDrive,
} from 'Utils/utils';
import intl from 'react-intl-universal';


export default class GoogleDriveApi {
  constructor() {
    this.gapi = null;
    this.downloadFileRequest = false;
    this.uploadFileRequest = false;
    this.updateFileRequest = false;
    this.cancelDownloadFileFn = null;
    this.cancelUploadFileFn = null;
    this.cancelUpdateFileFn = null;
    this.googleDriveAxios = null;
    this.CancelToken = axios.CancelToken;

    this.init();
  }
  init() {
    this.googleDriveAxios = axios.create({
      baseURL: GOOGLE_DRIVE_API.BASEURL,
    });
    this.googleDriveAxios.interceptors.request.use(
      (config) => {
        store.driveStore.numberOfAjaxCAllPendingIncrease();

        let accessToken = storageGetItem(localStorage, 'GoogleDriveAccessToken');

        if (accessToken) {
          config.headers = {
            Authorization: `Bearer ${accessToken}`,
            ...config.headers,
          };
        }

        if (!store.driveStore.loading) {
          store.driveStore.setLoadingState(true);
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
    this.googleDriveAxios.interceptors.response.use(
      (res) => {
        store.driveStore.numberOfAjaxCAllPendingDecrease();
        
        return res.data;
      },
      (error) => {
        store.driveStore.numberOfAjaxCAllPendingDecrease();
        
        this.errorHandler(error);
        
        return Promise.reject(error);

      },
    );
    GOOGLE_DRIVE_CONFIG.SET_APP_CONFIG()
  }
  getOAuthToken() {
    var user = this.gapi.auth2.getAuthInstance().currentUser.get();

    return user.getAuthResponse().access_token;
  }
  errorHandler(error) {
    let errorMsg;
    let status = error.status || (error.response && error.response.status);

    let lmsNoErr = false;
    if (error.__CANCEL__) {
      errorMsg = intl.formatMessage({ id: 'CancelRequest' });
    } else if (status === 403) {
        const { message } = error.response.data.error

        if (message === "The user does not have sufficient permissions for this file.") {
          errorMsg = intl.formatMessage({ id: 'GoogleDrivePermissionError'})
        } else {
          error.autoSignOut = true;
          errorMsg = intl.formatMessage({ id: 'InvalidToken' });
        }
    } else if (status === 404) {
      errorMsg = intl.formatMessage({ id: 'FileNotExist' });
    } else if (error && error.message.indexOf('401') > -1) {
      error.autoSignOut = true;
      errorMsg = intl.formatMessage({ id: 'DrivesListDlg.TokenExpire' });
    } else if (error.message === 'Network Error') {
      errorMsg = intl.formatMessage({ id: 'NetworkError' });
    } else {
      error.autoSignOut = true;
      lmsNoErr = true;
      errorMsg = intl.formatMessage({ id: 'Error.SignOutAndRetry' });
    }
    if(isCanvas()&&lmsNoErr) {
      saveNeedReLoginDrive();
      return;
    }
    store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });
  }
  signOut(success) {
    storageRemoveItem(localStorage, 'GoogleDriveAccessToken');
    success && success();
  }
  async downloadFile(item, success, fail) {
    let fileMetaData
    const { isFromGoogleDrive } = store.appStore.googleDriveInfo

    if (isFromGoogleDrive) {
      fileMetaData = await this.googleDriveAxios({
        url: `${GOOGLE_DRIVE_API.DOWNLOAD_FILE}/${item.id}`,
        method: 'GET',
        params: {
          fields: '*',
          supportsAllDrives: true,
          key: GOOGLE_DRIVE_CONFIG.API_KEY,
        }
      }).catch((error) => {        
        fail && fail(error.response);
      });

      const parents = (fileMetaData.parents && fileMetaData.parents[0]) || ''
      
      Object.assign(item, {name: getFileNameWithoutExtension(fileMetaData.name), parents})
    }

    this.downloadFileRequest = true;

    if (GOOGLE_EXCLUSIVE_MIME_TYPE.indexOf(item.mimeType) > -1 ) {
      this.googleDriveAxios({
        url: `${GOOGLE_DRIVE_API.EXPORT_FILE}/${item.id}/export`,
        method: 'GET',
        params: {
          fields: '*',
          mimeType: 'application/pdf',
          alt: 'media',
        },
        responseType: 'blob',
        cancelToken: new this.CancelToken((c) => {
          // An executor function receives a cancel function as a parameter
          this.cancelDownloadFileFn = c;
        }),
      }).then((res) => {
        this.downloadFileRequest = false;

        success && success({ blob: res, id: item.id, fileName: item.name, parents: item.parents });
      })
      .catch((error) => {
        this.downloadFileRequest = false;
        
        fail && fail(error.response);
      });

      return 
    }

    this.googleDriveAxios({
      url: `${GOOGLE_DRIVE_API.DOWNLOAD_FILE}/${item.id}`,
      method: 'GET',
      params: {
        fields: '*',
        key: GOOGLE_DRIVE_CONFIG.API_KEY,
        alt: 'media',
      },
      responseType: 'blob',
      cancelToken: new this.CancelToken((c) => {
        // An executor function receives a cancel function as a parameter
        this.cancelDownloadFileFn = c;
      }),
    })
      .then((res) => {
        this.downloadFileRequest = false;

        success && success({ blob: res, id: item.id, fileName: item.name, parents: item.parents });
      })
      .catch((error) => {
        this.downloadFileRequest = false;
        
        fail && fail(error.response);
      });
  }
  cancelDownloadFile() {
    this.cancelDownloadFileFn && this.cancelDownloadFileFn();
  }
  getUserInfo(success, fail) {
      this.googleDriveAxios({
        url: GOOGLE_DRIVE_API.GET_USER_INFO,
        method: 'GET',
        params: {
          fields: 'user',
        },
      })
        .then((res) => {
          let accessToken = storageGetItem(localStorage, 'GoogleDriveAccessToken');

          res.user.id = res.user.permissionId
          res.user.userAccount = res.user.emailAddress
          res.user.accessToken = accessToken
          setDriveTokenInfo(GOOGLE_DRIVE, res.user.userAccount)
          success && success(res.user);
          
        })
        .catch((error) => {
          fail && fail(error);
        });
  }
  getItems(folderId, success, fail) {
    const getQueryParams = () => {
      const isSharedDrive = false
      
      if (folderId) {
        return `'${folderId}' in parents and trashed = false`
      }

      if (isSharedDrive) {
        return "sharedWithMe = true and trashed = false"
      }

      return "('root' in parents or sharedWithMe) and trashed = false"
    }
    this.googleDriveAxios({
      url: GOOGLE_DRIVE_API.GET_FILES,
      method: 'GET',
      params: {
        // 不显示删除的文件
        // fields: 'nextPageToken, files(id, name, size, createdTime, mimeType, modifiedTime, permissions(role, emailAddress))',
        fields: 'nextPageToken, files(id, name, size, createdTime, mimeType, modifiedTime, webContentLink, webViewLink)',
        q: getQueryParams(),
        pageSize: 1000,
        orderBy: 'name',
      },
    }).then((res) => {
        let folders = [];
        let files = [];

        res.files.forEach((item) => {
          if (item.mimeType === 'application/vnd.google-apps.folder') {
            item.isFolder = true;
            item.size = ''
            item.modifiedTime = ''
            folders.push(item);
          }
          if (/* SUPPORT_FILE_EXTENSIONS.indexOf(item.name.replace(/.+\./,""))  > -1 */ SUPPORT_FILE_MIME_TYPES.indexOf(item.mimeType) > -1){
            // item.name = getFileNameWithExtension(item.name, item.mimeType)
            // if (GOOGLE_EXCLUSIVE_MIME_TYPE.indexOf(item.mimeType) > -1) {
            //   item.name = `${item.name}.pdf`
            // }
            item.originSize = item.size || '0KB'
            item.size = item.size && getFileSize(item.size) || '0KB'
            item.modifiedTime = convertUTCToLocale(item.modifiedTime);
            files.push(item);
          }
        });

        const { saveType } = store.driveStore

        if (saveType) {
          const targetMimeType = mimeMap[saveType]

          files = files.filter((item) => {
            return item.mimeType === targetMimeType
          })
        }
        res.result = {};
        res.result.files = [...folders, ...files];

        success && success(res);
      })
      .catch((error) => {
        fail && fail(error);
      });
  }
  getAccessToken(code, success, fail) {
    let fd = new FormData();

    fd.append('code', decodeURIComponent(code));
    fd.append('grant_type', 'authorization_code');
    fd.append('client_id', GOOGLE_DRIVE_CONFIG.CLIENT_ID);
    fd.append('client_secret', GOOGLE_DRIVE_CONFIG.CLIENT_SECRET);
    fd.append('redirect_uri', `${baseUrlApis.getBaseUrl()}GoogleDriveAuthrizationWin.html`)
    this.googleDriveAxios({
      url: GOOGLE_DRIVE_API.GET_ACCESS_TOKEN,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: fd,
    })
      .then((res) => {
        success && success(res);
      })
      .catch((error) => {
        fail && fail(error)
      });
  }
  redirectToGoogleOAuth(fileParams) {
    updateProp(location, 'href', `${GOOGLE_DRIVE_CONFIG.AUTHORIZATION_URL(fileParams)}`)
  }
  signInForGSuite(success) {
    const fileParams = getQueryVariable('state');
    const googleOAuthCode = getQueryVariable('googleOAuthCode')

    function onSignSuccess(token) {
      storageSetItem(localStorage, 'GoogleDriveAccessToken', token);
      saveNeedReLoginDrive(false);
      success && success();
    }

    if (fileParams && googleOAuthCode) {
      this.getAccessToken(googleOAuthCode, (res) => {
        onSignSuccess(res.access_token);
      });
    }
  }
  signIn(success, closeWin,fail) {
    let _this = this
    let left = window.innerWidth / 2 - 300;
    let _hTime = null;
    let _hWin = windowActionFn(window, 'open', [GOOGLE_DRIVE_CONFIG.AUTHORIZATION_URL(), 'GoogleDriveAuthorizationWin', `width=600, height=645, left=${left}, top=240`]);

    function onSignSuccess(token) {
      storageSetItem(localStorage, 'GoogleDriveAccessToken', token); //"null"
      success && success();
    }
    function onHandleWindowMessage(event) {
      let origin = baseUrlApis.getBaseUrl();

      if (event.data.googleDriveCode && `${event.origin}/` === origin) {
        _this.getAccessToken(event.data.googleDriveCode, (res) => {
          clean();
          onSignSuccess(res.access_token);
          // todo 集成后 没有存进去
          console.log('author res --->',res);
          console.log('author google refresh token IMPORTANT--->',res.refresh_token);
          saveDriveRefreshCode('google',res.refresh_token);
        },
        (error) => {
          fail && fail(error)
        });
      }
    }
    function onHandleStorage(e) {
      if (e.key === 'googleDriveCode') {
        onSignSuccess(e.newValue);
        clean();
      }
    }
    function clean() {
      if (!_hWin) {
        
        return;
      }
      _hWin.close();
      _hWin = null;
      closeWin && closeWin()
      _hTime && clearInterval(_hTime);
      _hTime = null;
      window.removeEventListener('message', onHandleWindowMessage);
      window.removeEventListener('storage', onHandleStorage);
    }
    // start to listen
    _hTime = setInterval(() => {
      if (_hWin.closed) {
        
        clean();
      }
    }, 2000);

    window.addEventListener('message', onHandleWindowMessage, false);
    window.addEventListener('storage', onHandleStorage, false);
  }
  updateFileMultipart(fileId, file) {
    var fr = new FileReader();
    var nSize = file.size;
    var contentType = file.type || 'application/octet-stream';

    fr.onload = (evt) => {
      var boundary = '-------314159265358979323846';
      var delimiter = '\r\n--' + boundary + '\r\n';
      var close_delim = '\r\n--' + boundary + '--';
      var metadata = {
        name: file.name,
        mimeType: contentType,
        'Content-Type': contentType,
        'Content-Length': nSize,
      };
      var base64Data = evt.target.result.replace(/^data:.*;base64,/, ''); //btoa(evt.target.result);
      var multipartRequestBody =
        delimiter +
        'Content-Type: application/json\r\n\r\n' +
        JSON.stringify(metadata) +
        delimiter +
        'Content-Type: ' +
        contentType +
        '\r\n' +
        'Content-Transfer-Encoding: base64\r\n' +
        '\r\n' +
        base64Data +
        close_delim;
      var request = this.gapi.client.request({
        path: `${GOOGLE_DRIVE_API.UPDATE_FILE}/${fileId}`,
        method: 'POST',
        params: { uploadType: 'multipart' },
        headers: {
          'Content-Type': 'multipart/related; boundary="' + boundary + '"',
          'Content-Length': multipartRequestBody.length,
        },
        body: multipartRequestBody,
      });
      request.execute(
        function (/* response */) {
          
        },
        (error) => {
          this.errorHandler(error);
        },
      );
    };

    fr.readAsDataURL(file);
  }
  createFolder({folderName, folderPath}) {
    const data = JSON.stringify({
      mimeType: 'application/vnd.google-apps.folder',
      name: folderName,
      parents: folderPath[folderPath.length - 1].id ? [folderPath[folderPath.length - 1].id] : 'root',
    })

    return this.googleDriveAxios({
      url: GOOGLE_DRIVE_API.CREATE_FOLDER,
      method: 'POST',
      data,
      params: {
        fields: 'id, name, createdTime, mimeType',
      },
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  listFolder({folderName='',parentId='root'}){
    let qStr = `mimeType='application/vnd.google-apps.folder' and '${parentId}' in parents and trashed = false`
    if(folderName){
        qStr = `name='${folderName}' and ${qStr}`;
    }
    return this.googleDriveAxios({
      url: GOOGLE_DRIVE_API.LIST_FOLDER,
      method: 'GET',
      params: {
        fields: '*',
        q: qStr,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  listFiles({parentId='root', fileName=''}){
    let qStr = `'${parentId}' in parents and trashed = false`;
    if(fileName){
      qStr = `name='${fileName}' and ${qStr}`;
    }
    return this.googleDriveAxios({
      url: GOOGLE_DRIVE_API.LIST_FILES,
      method: 'GET',
      params: {
        fields: '*',
        q: qStr,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  createFileMultipart(file, folderPath, success, fail, progress, mimeType, fileType) {
    var fr = new FileReader();
    var nSize = file.size;
    var contentType = file.type || 'application/octet-stream';
    let fileName = file.name.indexOf('.') > 0 ? file.name : `${file.name}.${fileType}`;

    this.uploadFileRequest = true;

    fr.onload = (evt) => {
      var boundary = '-------314159265358979323846';
      var delimiter = '\r\n--' + boundary + '\r\n';
      var close_delim = '\r\n--' + boundary + '--';
      var metadata = {
        name: fileName,
        mimeType: mimeType,
        parents: folderPath[folderPath.length - 1].id ? [folderPath[folderPath.length - 1].id] : 'root',
        'Content-Type': mimeType,
        'Content-Length': nSize,
      };
      let media = {
        mimeType:file.type,
        name:file.name
      }
      var base64Data = evt.target.result !== 'data:' ? evt.target.result.replace(/^data:.*;base64,/, '') : ''; //btoa(evt.target.result);
      var multipartRequestBody =
        delimiter +
        'Content-Type: application/json\r\n\r\n' +
        JSON.stringify(metadata) +
        delimiter +
        'Content-Type: ' +
        contentType +
        '\r\n' +
        'media: ' +
        JSON.stringify(media) +
        '\r\n' +
        'Content-Transfer-Encoding: base64\r\n' +
        '\r\n' +
        base64Data +
        close_delim;

      this.googleDriveAxios({
        url: GOOGLE_DRIVE_API.CREATE_FILE,
        method: 'POST',
        params: {
          uploadType: 'multipart',
          fields: '*',
        },
        headers: {
          'Content-Type': 'multipart/related; boundary="' + boundary + '"',
          'media': media
          // 'Content-Length': multipartRequestBody.length,
        },
        data: multipartRequestBody,
        onUploadProgress: function (progressEvent) {
          if (progressEvent.lengthComputable) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

            progress && progress(percentCompleted);
          }
        },
        cancelToken: new this.CancelToken((c) => {
          // An executor function receives a cancel function as a parameter
          this.cancelUploadFileFn = c;
        }),
      })
        .then((res) => {
          this.uploadFileRequest = false;
          success && success(res);
        })
        .catch((error) => {
          this.uploadFileRequest = false;
          
          fail && fail(error);
        });
    };

    fr.readAsDataURL(file);
  }
  cancelUploadFile() {
    this.cancelUploadFileFn && this.cancelUploadFileFn();
  }
  updateFileSimpleUpload(fileId, file, success, fail, progress,mimeType) {
    // let nSize = file.size;

    let contentType = !!mimeType?mimeType: file.type || 'application/octet-stream';

    this.updateFileRequest = true;
    return this.googleDriveAxios({
      url: `${GOOGLE_DRIVE_API.UPDATE_FILE}/${fileId}`,
      method: 'PATCH',
      headers: {
        'Content-Type': contentType,
        // 'Content-Length': nSize,
      },
      params: {
        key: GOOGLE_DRIVE_CONFIG.API_KEY,
        uploadType: 'media',
        fields: '*',
      },
      data: file,
      onUploadProgress: function (progressEvent) {
        if (progressEvent.lengthComputable) {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

          progress && progress(percentCompleted);
        }
      },
      cancelToken: new this.CancelToken((c) => {
        // An executor function receives a cancel function as a parameter
        this.cancelUpdateFileFn = c;
      }),
    })
      .then((res) => {
        this.updateFileRequest = false;

        success && success(res);
      })
      .catch((error) => {
        this.updateFileRequest = false;

        fail && fail(error);

        throw 'error'
      });
  }
  cancelUpdatedFile() {
    this.cancelUpdateFileFn && this.cancelUpdateFileFn();
  }

  async getTokenByRefreshToken (refresh_token){
    let fd = new FormData();
    fd.append('client_secret', GOOGLE_DRIVE_CONFIG.CLIENT_SECRET);
    fd.append('grant_type', 'refresh_token');
    fd.append('refresh_token', refresh_token);
    fd.append('client_id', GOOGLE_DRIVE_CONFIG.CLIENT_ID);
    try {
        const res = await this.googleDriveAxios({
          url: GOOGLE_DRIVE_API.GET_ACCESS_TOKEN,
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          data: fd,
        });
        return res;
    }catch (err){
        return err;
    }
  }


  async reBuildTokenByRefreshToken(refresh_token){
      saveDriveRefreshCode('google',refresh_token);

      const res = await this.getTokenByRefreshToken(refresh_token);
      if(res && res.access_token){
        console.log('rebuild token ok',res.access_token);
          storageSetItem(localStorage, 'GoogleDriveAccessToken', res.access_token);
          saveNeedReLoginDrive(false);
      }else{
        console.log('rebuild token error',res);
        saveNeedReLoginDrive(true);
      }
      return res;
  }

  async isSignIn() {
    let accessToken = storageGetItem(localStorage, 'GoogleDriveAccessToken');

    if (accessToken) {
      return true;
    }

    const refresh_code = getDriveRefreshCode('google');
    console.log('issignin refresh code from local',refresh_code);
    if(refresh_code){
        const result = await this.getTokenByRefreshToken(refresh_code);
        if(result && result.access_token){
          console.log('is sign in token ok',result.access_token);
            storageSetItem(localStorage, 'GoogleDriveAccessToken', result.access_token);
            saveNeedReLoginDrive(false);
            return true;
        }else{
          console.log('is sign in token error',result);
           saveNeedReLoginDrive(true);
           return false;
        }
    }
    return false;
  }
}
